module.exports = __webpack_public_path__ + "static/media/settingsGear.5eb92cf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/settingsGear.png
// module id = 148
// module chunks = 0